import { Container } from '@material-ui/core';
import SearchClient from '../components/clients/SearchClient';
import Page from '../components/Page';

export default function Client() {
  return (
    <Page title="Dashboard: Client | ZIMTA">
      <Container>
        <SearchClient />
      </Container>
    </Page>
  );
}
